import React from 'react';

import { useTheme } from '@codes/theme';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    darkSrc?: string;
}

// TODO: 사전 로딩 추가
export const Image = (props: ImageProps) => {
    const { isDarkTheme } = useTheme();
    const { src, darkSrc = src, alt = '', ...restProps } = props;

    return <img {...restProps} src={isDarkTheme ? darkSrc : src} alt={alt} />;
};
